import PageTitle from '@/components/PageTitle/PageTitle';
export default PageTitle;
